var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('ul',{staticClass:"menu1"},_vm._l((_vm.navList),function(items,key){return (_vm.getToken)?_c('li',{key:key,class:{ active: _vm.active_idx == key },on:{"click":function($event){return _vm.activeFun(key)}}},[_c('i',{class:items.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(items.text))])]):_vm._e()}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f54e1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/com-menu.vue
// module id = null
// module chunks = 